function collaborationSlider() {
    const $slideshow = $('.instagram-feed-container');

    $slideshow.slick({
        dots: false,
        arrows: false,
        slidesToShow: 5.5,
        slidesToScroll: 1,
        speed: 600,
        autoplay: true,
        //infinite: false,
        swipeToSlide: true,
        touchThreshold: 100,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 4.2
                }
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 2.2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.2
                }
            }
        ]
    });
}

$(document).ready(function() {
    collaborationSlider();
});
